// extracted by mini-css-extract-plugin
var _1 = "VideoPreview-moduleVideoPreview__UYOoU";
export { _1 as "VideoPreview" }
